import React, { useContext } from "react";
import clsx from "classnames";
import { ReactComponent as BuyWaterSvg } from "../../svgs/SideNav/buywater.svg";
import { ReactComponent as LogoutSvg } from "../../svgs/SideNav/logout.svg";
import { ReactComponent as ReportLeakagSvg } from "../../svgs/SideNav/reportLeakage.svg";
import { ReactComponent as TransactionsSvg } from "../../svgs/SideNav/transactions.svg";
import { ReactComponent as LogInSvg } from "../../svgs/login.svg";
import { ReactComponent as MeterSvg } from "../../svgs/SideNav/meter.svg";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../helper/auth";
import { LogContent } from "../../helper/context";
import { routes } from "../../helper/misc";
import Logo from "./Logo";

function SideNav({ className }) {
  const auth = useAuth();
  const { setDisplayMeta } = useContext(LogContent);
  const { pathname } = useLocation();

  const pageIs = (path) => pathname.includes(path);

  const { user, hasMeters } = auth;

  return (
    <div
      className={clsx(
        "bg-[#F3F5F9] fixed h-full hidden md:hidden lg:block pt-10 w-[300px]",
        className
      )}
    >
      <div className="ml-5">
        <Logo />
      </div>

      <div className="text-sm mt-8 font-medium pt-2">
        {hasMeters && (
          <Link
            to="/buy-water"
            className={clsx({
              "pointer-events-none cursor-not-allowed opacity-50": !user,
            })}
          >
            <div
              className={clsx(
                { "bg-pw-blue !text-white": pageIs(routes.buy_water) },
                "flex items-center py-3 hover:bg-pw-blue/[.6] w-full text-[#979797] hover:text-white pl-8"
              )}
            >
              <span className="mr-[18px]">
                <BuyWaterSvg className="stroke-current fill-current" />
              </span>
              <h4>BuyWater</h4>
            </div>
          </Link>
        )}

        <Link
          to="/transactions"
          className={clsx({
            "pointer-events-none cursor-not-allowed opacity-50": !user,
          })}
        >
          <div
            className={clsx(
              { "bg-pw-blue !text-white": pageIs(routes.transactions) },
              "flex items-center py-3 hover:bg-pw-blue/[.6] w-full text-[#979797] hover:text-white pl-8"
            )}
          >
            <span className="mr-[23.5px]">
              <TransactionsSvg className="stroke-current" />
            </span>
            <h4>Transactions</h4>
          </div>
        </Link>
        {/* report leakage */}
        <Link
          to="/report-leakage"
          className={clsx({
            "pointer-events-none cursor-not-allowed opacity-50": !user,
          })}
        >
          <div
            className={clsx(
              { "bg-pw-blue !text-white": pageIs(routes.report_leakage) },
              "flex items-center py-3 hover:bg-pw-blue/[.6] w-full text-[#979797] hover:text-white pl-8"
            )}
          >
            <span className="mr-[18px]">
              <ReportLeakagSvg className="fill-current" />
            </span>
            <h4>Report Leakage</h4>
          </div>
        </Link>
        {/* manage meters */}
        <Link
          to="/manage-meters"
          className={clsx({
            "pointer-events-none cursor-not-allowed opacity-50": !user,
          })}
        >
          <div
            className={clsx(
              { "bg-pw-blue !text-white": pageIs(routes.manage_meters) },
              "flex items-center py-3 hover:bg-pw-blue/[.6] w-full text-[#979797] hover:text-white pl-8"
            )}
          >
            <span className="mr-[18px]">
              <MeterSvg className="fill-current h-8 w-8" />
            </span>
            <h4>Manage Meters</h4>
          </div>
        </Link>
        {!user ? (
          <Link to="/login">
            <div
              className={clsx(
                { "bg-pw-blue !text-white": pageIs(routes.login) },
                "flex items-center py-3 hover:bg-pw-blue/[.6] w-full text-[#979797] hover:text-white pl-8"
              )}
            >
              <span className="mr-[21px]">
                <LogInSvg className="fill-current" />
              </span>
              <h4>Log in</h4>
            </div>
          </Link>
        ) : (
          <div
            role="button"
            className={clsx(
              "flex items-center py-3 hover:bg-pw-blue/[.6] w-full text-[#979797] hover:text-white pl-8"
            )}
            onClick={() => {
              setDisplayMeta(true);
            }}
          >
            <span className="mr-[18px]">
              <LogoutSvg className="fill-current" />
            </span>
            <h4>Log out</h4>
          </div>
        )}
      </div>
    </div>
  );
}

export default SideNav;
